import * as actionTypes from "../actions/actionTypes";

export default (state = {}, { type, data }) => {
  switch (type) {
    case actionTypes.ARTICLE_ITEM_DETAIL:
      return data;
    default:
      return state;
  }
};
